"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = require("bignumber.js");
class cosmosBase {
    constructor() {
        this.defaultGas = 100000;
        this.minGasPrice = 0.0025;
        this.minimalTransactionAmount = new bignumber_js_1.BigNumber(10000);
        this.version = "v1beta1";
    }
}
cosmosBase.COSMOS_FAMILY_LEDGER_VALIDATOR_ADDRESSES = [];
exports.default = cosmosBase;
//# sourceMappingURL=cosmosBase.js.map